import React from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from "@mui/material";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import CheckCircle from "@mui/icons-material/CheckCircle";
import Warning from "@mui/icons-material/Warning";
import Work from "@mui/icons-material/Work";
import Notifications from "@mui/icons-material/Notifications";
import styles from "../Scrollarea.module.css";

const VendorDashboardNotification = () => {
  const notifications = [
    {
      id: 1,
      type: "payment",
      title: "Payment Notification",
      description: "Lorem Ipsum is simply dummy text of the printing.",
      time: "10 mins ago",
      icon: <CheckCircle sx={{ color: "#22c55e" }} />,
      bgColor: "#e8f5e9",
    },
    {
      id: 2,
      type: "issue",
      title: "Issues Notification",
      description: "Friday, February 10, 2023 at 5:57 PM",
      icon: <Warning sx={{ color: "#ef4444" }} />,
      bgColor: "#ffebee",
      action: "Undo",
    },
    {
      id: 3,
      type: "job",
      title: "Jobs Notification",
      description: "Lorem Ipsum is simply dummy text.",
      time: "10 mins ago",
      icon: <Work sx={{ color: "#a855f7" }} />,
      bgColor: "#f3e5f5",
    },
    {
      id: 4,
      type: "notification",
      title: "Notification title",
      description: "",
      time: "10 mins ago",
      icon: <Notifications sx={{ color: "#3b82f6" }} />,
      bgColor: "#e3f2fd",
    },
    {
      id: 4,
      type: "notification",
      title: "Notification title",
      description: "",
      time: "10 mins ago",
      icon: <Notifications sx={{ color: "#3b82f6" }} />,
      bgColor: "#e3f2fd",
    },
    {
      id: 4,
      type: "notification",
      title: "Notification title",
      description: "",
      time: "10 mins ago",
      icon: <Notifications sx={{ color: "#3b82f6" }} />,
      bgColor: "#e3f2fd",
    },
  ];
  return (
    <Card
      elevation={1}
      sx={{
        borderRadius: 5,
        boxShadow: 6,
        p: 2,
        width: "100%", // takes full width of parent
        minHeight: "100%",
        margin: "auto",
      }}
    >
      <Box
        mx={2}
        py={1}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        borderBottom={1}
        borderColor="divider"
        mb={1}
      >
        <Typography variant="h5" fontWeight={700}>
          Notifications
        </Typography>
        <Button
          variant="subtitle2"
          size="small"
          color="primary"
          sx={{ fontWeight: 500, textTransform: "none" }}
        >
          View
        </Button>
      </Box>

      <CardContent sx={{ pt: 0 }}>
        {/* Date Row */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mb: 1,
            gap: 0.5,
            color: "text.secondary",
            fontSize: 14,
            fontWeight: 500,
          }}
        >
          24 Jun 2024
          <KeyboardArrowDown fontSize="small" />
        </Box>

        {/* Notification List */}
        <List
          disablePadding
          className={`${styles.scrollContainerforDashboard}`}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            overflowY: "auto",
            maxHeight: "260px",
          }}
        >
          {notifications.map((notification) => (
            <ListItem
              key={notification.id}
              sx={{
                borderRadius: 2,
                bgcolor: "#f9fafb",
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              {/* Icon */}
              <ListItemAvatar>
                <Avatar
                  sx={{
                    bgcolor: notification.bgColor,
                    width: 40,
                    height: 40,
                  }}
                >
                  {notification.icon}
                </Avatar>
              </ListItemAvatar>

              {/* Title, Time, and Description */}
              <ListItemText
                primary={
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography fontSize={14} fontWeight={600}>
                      {notification.title}
                    </Typography>
                    {notification.time && (
                      <Typography fontSize={12} color="text.secondary">
                        {notification.time}
                      </Typography>
                    )}
                  </Box>
                }
                secondary={
                  notification.description && (
                    <Typography
                      fontSize={12}
                      color="text.secondary"
                      sx={{ mt: 0.5 }}
                    >
                      {notification.description}
                    </Typography>
                  )
                }
              />

              {/* Action (like Undo) */}
              {notification.action && (
                <ListItemSecondaryAction
                  sx={{ top: "50%", transform: "translateY(-50%)" }}
                >
                  <Button size="small" sx={{ fontSize: 12 }} color="primary">
                    {notification.action}
                  </Button>
                </ListItemSecondaryAction>
              )}
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

export default VendorDashboardNotification;
